import React from 'react'
import { Container, Form, Row, Col, Button } from 'react-bootstrap'
import './../style.scss'
import { CarService, UserService } from '@src/domain/services'
import { useForm } from '@src/lib/react-hook-form'
import { z } from 'zod'
import { SearchCondition } from '../report.view-model'
import { FaSearch, PiMicrosoftExcelLogoBold } from '@src/lib/react-icons'
import _ from 'lodash'

interface CarInfosSaerchBarProps {
  factoryOptions: UserService.FactoriesBo;
  carModelOptions: CarService.CarModelsBo;
  searchCondition: SearchCondition;
  searchOnClick: (condition: SearchCondition) => void;
  downloadOnClick: (condition: SearchCondition) => void;
}

export const CarInfosSaerchBar: React.FC<CarInfosSaerchBarProps> = ({factoryOptions, carModelOptions, searchCondition, searchOnClick, downloadOnClick}) => {
  const { register, handleSubmit, formState: { errors }, setValue  } = useForm<SearchCondition>({
    reValidateMode: 'onSubmit',
    defaultValues: searchCondition,
    rules: z.object({
      factoryUuid: z.string().nonempty({ message: '請選擇廠區' }),
      status: z.string().optional(),
      carModelUuid: z.string().optional(),
      engineNo: z.string().optional(),
      sfxNo: z.string().optional(),
      shippingNo: z.string().optional()
    })
  })

  const handleOnSubmit = (dto: SearchCondition) => {
    searchOnClick(dto)
  }

  const handleOnDownload = (dto: SearchCondition) => {
    downloadOnClick(dto)
  }

  const handleTextOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setValue(name, value.toUpperCase(), { shouldValidate: true })
  }

  return (
    <div className='search-bar-wrap'>
      <Container>
        <Form onSubmit={handleSubmit(handleOnSubmit)}>
          <Row className='mb-3'>
            <Form.Group as={Col}>
              <Form.Label>廠區</Form.Label>
              <Form.Select {...register('factoryUuid')}>
                <option value=''>請選擇廠區</option>
                {
                  factoryOptions
                    .filter(o => o.code !== 'ALL')
                    .map(option => <option key={option.uuid} value={option.uuid}>{`${option.code}-${option.description}`}</option>)
                }
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>完成狀態</Form.Label>
              <Form.Select {...register('status')}>
                <option value=''>請選擇狀態</option>
                <option value='AS2'>組裝中</option>
                <option value='AS3'>已組裝</option>
                <option value='QA2'>品檢中</option>
                <option value='QA3'>已品檢</option>
                <option value='RP2'>修復中</option>
                <option value='RP3'>已修復</option>
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>車種</Form.Label>
              <Form.Select {...register('carModelUuid')}>
                <option value=''>請選擇車種</option>
                {
                  carModelOptions.map(option => <option key={option.uuid} value={option.uuid}>{`${option.description}`}</option>)
                }
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col}>
              <Form.Label>引擎編號</Form.Label>
              <Form.Control {...register('engineNo')} onChange={handleTextOnChange} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>SFX NO</Form.Label>
              <Form.Control {...register('sfxNo')} onChange={handleTextOnChange} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>船次</Form.Label>
              <Form.Control {...register('shippingNo')} />
            </Form.Group>
          </Row>
          <div className='d-flex gap-2 btn-row'>
            <div className='error-div'>{_(errors).pickBy(v => !_.isEmpty(v)).mapValues(v => v.message).map().join('、')}</div>
            <Button variant='primary' type='submit'>
              <FaSearch />
              查詢
            </Button>
            <Button variant='success' onClick={handleSubmit(handleOnDownload)}>
              <PiMicrosoftExcelLogoBold />
              下載
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  )
}
